export const QueueType = {
	all: 'all',
	strictly: 'strictly',
	evenly: 'evenly',
};
